// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

import l10n from './l10n';

export default {
	EstateSlider: codeSplit( {
		l10n,
		loadComponent: () =>
			import(
				/* webpackChunkName: "EstateSlider" */
				'./index'
			),
	} ),
};
